export class FileTemplate {
  id: number;
  fileTypeId: string;
  displayName: string;
  fileName?: string;
  partial: boolean;
}
